import React from "react";
import { Routes, Route } from "react-router-dom";
import BillingAddress from "../card/account/BillingAddressCard.js";
import { PageCardColumn, PageContainer, PageLeftColumn } from "../../styles/Page.js";
import ShippingAddress from "../card/account/ShippingAddressCard.js";
import EditAccountNav from "../sidebar/EditAccountNav.js";
import { useSelector } from "react-redux";
import Modal from "../main/Modal.js";
import LabeledSpinner from "../main/LabeledSpinner.js";

const AccountPage = () => {
  const customer = useSelector((state) => state.customer);
  return (
    <PageContainer>
      <PageLeftColumn>
        <EditAccountNav />
      </PageLeftColumn>
      <PageCardColumn>
        <Routes>
          <Route
            path="/billing-address"
            element={<BillingAddress />}
          />
          <Route
            path="/shipping-address"
            element={<ShippingAddress />}
          />
        </Routes>
      </PageCardColumn>
      { customer?.fetching && 
        <Modal>
          <LabeledSpinner text={"Fetching your details..."} />
        </Modal>
      }
    </PageContainer>
  );
};

export default AccountPage;
